import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { useI18next } from "gatsby-plugin-react-i18next";

import { colors, down } from "~/src/config/vars";

const BlockRegistration = () => {
    const { language } = useI18next();
    const typeformRef = useRef(null);

    const uri =
        language === "ru"
            ? "https://o15hvpsx4tf.typeform.com/to/uQoN4EZS"
            : "https://o15hvpsx4tf.typeform.com/to/v5YxiZgP";

    useEffect(() => {
        (async () => {
            const { makeWidget } = await import("@typeform/embed");
            makeWidget
                ? makeWidget(typeformRef.current, uri, {
                      hideFooter: true,
                      hideHeaders: true,
                      opacity: 0,
                      hideScrollbars: false,
                  })
                : null;
        })();
    }, [typeformRef]);

    return (
        <SBlockRegistration>
            <SBlock>
                <STypeform ref={typeformRef} />
            </SBlock>
        </SBlockRegistration>
    );
};

const SBlockRegistration = styled.div`
    position: relative;
    background-color: ${colors?.black};
    ${down("sm")} {
    }
`;

const SBlock = styled.div`
    iframe {
        width: 100%;
        height: 650px;
        ${down("sm")} {
            height: 500px;
        }
    }
    ${down("md")} {
    }
`;
const STypeform = styled.div``;

export default BlockRegistration;
